var exports = {
  "e": "xdde3148b--17a613--disclaimer",
};

module.exports = exports;
